import * as Sentry from '@sentry/browser'

import {
  denyUrls,
  ignoreErrors
} from './components/ConfigureSentryMetadata/ignorePatterns'

const IGNORED_USER_AGENTS = /google-read-aloud/i
/**
 * Here we ignore error from bots that are just adding
 * noise to our logs.
 */
const beforeSend = (event, hint) => {
  if (IGNORED_USER_AGENTS.test(navigator.userAgent)) {
    return null
  }

  // Filter ChunkLoadError errors. We report them as ModuleLoadError.
  if (event.exception?.values?.[0]?.type === 'ChunkLoadError') {
    return null
  }

  // Filter CSS loading errors. We report them as ModuleLoadError.
  if (event.exception?.values?.[0]?.value.startsWith('Loading CSS chunk')) {
    return null
  }

  // Filter Google One Tap error by message
  const error = hint?.originalException
  if (error?.message?.match(/malformed JSON response/i)) {
    return null
  }

  return event
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  sendDefaultPii: false,
  integrations: [Sentry.featureFlagsIntegration()],
  environment: process.env.NEXT_PUBLIC_ENV,
  release: process.env.NEXT_PUBLIC_APP_VERSION,
  denyUrls,
  ignoreErrors,
  beforeSend
})
